<template>
    <el-tooltip
        class="box-item"
        effect="dark"
        content="Please remove all takers configuration in this region first"
        :disabled="!disableOption"
        placement="top"
    >
        <el-option
            :label="region.display_name"
            :value="region.uid"
            :disabled="disableOption"
        ></el-option>
    </el-tooltip>
</template>

<script>import { mapGetters } from 'vuex';
export default {

    name: 'RegionOption',
    props:{
        region :{
            type: Object,
            required: true,
        },
        feedResource:{
            type: Object,
            required: false,
            default: ()=>{return null;}
        },
        currentRegions: {
            type: Array,
            required: false,
            default: ()=>{return [];}
        },
        feedResourceConfigurations:{
            type: Array,
            required: false,
            default: ()=>{return [];}
        },
    },
    computed:{
        ...mapGetters([
            'takersByUid',
        ]),
        disableOption(){
            if(this.feedResource && this.currentRegions.includes(this.region.uid)){
                let confRelatedToRegion = this.feedResourceConfigurations
                    .filter(conf =>
                        conf.finished === false
                        && (
                            conf.aws_region_uid === this.region.uid
                            || this.takersByUid(conf.taker_uid).aws_region_uid === this.region.uid
                        )
                        && conf.feed_resource_uid === this.feedResource.uid
                    )
                return confRelatedToRegion.length > 0;
            }
            return false;
        }
    }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/region-option.vue